module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAABCUlEQVQ4jZ2UTyuFQRTGfyZ7WUjKQvb+fQeKFUXJxo6VzV34CJbKxgewsdD9AGRjxYpYCWVHWUhRUlf3Z/G+N0Pvn7n3qWnOnDnPc87UOYO6rZ6pqyoJa0g9UJ/UFfzFQwJ5TX2OOOcB+CLDJ+UYBZrAITAS+VsBaHUOJeRN4AZYLrj77q/IOg7sAksVMYQSeyvPWkkGiCt4BcaAPWCxjlgkMAFcAYOp5P8Cw90QOwj1IekCl2Tv71ngA2gA88BjLwID+X4CzAD73Qq0I/udrBcWgPtUgSIcA1NkHVmEPtR2Plm3NZM4p177FxcBeMvVXmqqOQWmgZ3Id4e6rjbV2cQPBXVDPVInfwCEPPEHgYCGdAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_left.png
// module id = akaD
// module chunks = 1